var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "modal-header" }, [
      _c(
        "button",
        {
          staticClass: "close",
          attrs: { type: "button", "aria-label": "Close" },
          on: {
            click: function ($event) {
              return _vm.modal.dismiss()
            },
          },
        },
        [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
      ),
      _vm._v(" "),
      _c("h3", { staticClass: "modal-title flex-around-center" }, [
        _c("div", { staticClass: "flex-column flex-center-start" }, [
          _c("span", { staticClass: "display-2" }, [
            _vm._v("Payer l'addition"),
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "display-6" }, [
            _vm._v(
              _vm._s(_vm.order.shop.DefaultName) +
                " - " +
                _vm._s(_vm.order.shop.City)
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "flex-column flex-center-center" }, [
          _vm.order.Table
            ? _c("span", { staticClass: "display-4" }, [
                _vm._v("Table " + _vm._s(_vm.order.Table)),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("span", { staticClass: "display-6" }, [
            _vm._v("Ticket nº" + _vm._s(_vm.order.TicketId)),
          ]),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("form", { attrs: { onsubmit: "return false" } }, [
      _c(
        "div",
        { staticClass: "modal-body" },
        [
          _c("h3", { staticClass: "flex-between-center" }, [
            _c("span", [_vm._v("Montant du ticket")]),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.ShopService.prix(_vm.order.Total)))]),
          ]),
          _vm._v(" "),
          _c("order-summary-mini-copy", { attrs: { order: _vm.order } }),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c("h3", [
            _vm.order.Remain != 0
              ? _c("div", { staticClass: "d-flex justify-content-between" }, [
                  _c("div", { staticClass: "col-sm-6 pl-0" }, [
                    _vm._v("Payer"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "align-item-center d-flex gap-2 justify-content-center align-items-center",
                      staticStyle: { "max-width": "40%", "font-size": "large" },
                    },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.order.PaymentAmount,
                            expression: "order.PaymentAmount",
                          },
                        ],
                        ref: "input",
                        staticClass: "form-control fsize-24 text-right pr-5",
                        attrs: { type: "tel", step: "any", min: "0" },
                        domProps: { value: _vm.order.PaymentAmount },
                        on: {
                          input: [
                            function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.order,
                                "PaymentAmount",
                                $event.target.value
                              )
                            },
                            function ($event) {
                              _vm.errorMsg = ""
                            },
                          ],
                        },
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "fsize-24 ml-2" }, [
                        _vm._v(_vm._s(_vm.order.Currency)),
                      ]),
                    ]
                  ),
                ])
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c("div", [
            _c("div", { staticClass: "col-sm-12 text-danger" }, [
              _vm._v(_vm._s(_vm.errorMsg)),
            ]),
          ]),
          _vm._v(" "),
          _vm.order.oi && _vm.order.oi.length
            ? _c(
                "div",
                [_c("VueJsonPretty", { attrs: { data: _vm.order.oi } })],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "text-center" },
            [
              _c("checkout-client-login", {
                on: {
                  after: function ($event) {
                    return _vm.UiService.openTicketModal(_vm.order)
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "modal-footer" }, [
        _vm.order.TicketId
          ? _c(
              "button",
              {
                staticClass: "btnFlat-color1 w-100",
                class: { "bg-bo-grey2": _vm.order.Remain == 0 },
                attrs: { disabled: _vm.order.Remain == 0 },
                on: {
                  click: function ($event) {
                    return _vm.validateAmountAndGo()
                  },
                },
              },
              [
                _vm.order.Remain != 0
                  ? _c("span", [
                      _vm._v(
                        "Payer " +
                          _vm._s(_vm.ShopService.prix(_vm.parsedAmount()))
                      ),
                    ])
                  : _c("span", [_vm._v("tout est bon, déjà réglé")]),
                _vm._v(" "),
                _c("i", { staticClass: "icone icone-lock" }),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        !_vm.order.TicketId
          ? _c("h2", { staticClass: "text-danger text-center" }, [
              _vm._v("Numéro de ticket invalide"),
            ])
          : _vm._e(),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }